<template>
<div id="home">
    <vue-headful
        title="EXTEND ME  - Home"
        description="EXTEND ME "
    />
</div>
</template>

<script>
import {mapGetters} from 'vuex';

export default{
    name:'HomeBase',
    data: function () {
        return { contact: {}, working: false}
    },
    computed: {
        ...mapGetters([
            "getLoginPossible", "getTestLoginPossible", "getLoginPossibleText",
            "getUserToken", "isDealerAdmin", "getCompany"
            ])
    },
    mounted () {
        let self = this
        if (this.getUserToken) {
            const now = new Date ()
            const tct = this.$store.state.user.tokenCreationTime
            console.log (now, tct)
            if (  (tct == null)
               || (now.getDate () != tct.getDate ())
               || ((now - tct) > 86400000)
               ) {
                   console.log ("LOGOUT", )
                   this.$store.dispatch ("logout")
            } else {
                console.log ("KEEP LOGGED IN")
                this.$store.commit ("SET_LOGIN_ACTIVE", true)
                if (this.isDealerAdmin) {
                    console.log ("TO Dealer Admin")
                    this.$router.push ({ name: "companies", params: {cid: this.getCompany}})
                } else {
                    // redirect to shop
                    console.log ("TO SHOP")
                    this.$store.dispatch ("redirect2Shop")
                }
            }
        } else {
            this.$store.commit ("SET_LOGIN_ACTIVE", false)
        }
    }
}
</script>
